const services = [
  {
    id: 1,
    title: "Mechanical Repair",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam id dolor id nibh ultricies vehicula ut id elit. Nullam id dolor id nibh ultricies vehicula ut id elit.",
    icon: "/assets/mechanic.png",
    price: 11,
    list: ["Hi", "Hello", "Bye"],
  },
  {
    id: 2,
    title: "Plumbing Repair",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam id dolor id nibh ultricies vehicula ut id elit. Nullam id dolor id nibh ultricies vehicula ut id elit.",
    icon: "/assets/plumber.png",
    price: 9,
    list: ["Hi", "Hello", "Bye"],
  },
  {
    id: 3,
    title: "Electrical Repair",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam id dolor id nibh ultricies vehicula ut id elit. Nullam id dolor id nibh ultricies vehicula ut id elit.",
    icon: "/assets/electrician.png",
    price: 13,
    list: ["Hi", "Hello", "Bye"],
  },
];

export default services;
